import { Component, OnInit, ViewChild } from '@angular/core';
import { NavController, Platform, MenuController, ToastController } from '@ionic/angular';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonDeclarationService } from 'src/app/service/common/common-declaration.service';
import { CommonDefinitionService } from 'src/app/service/common/common-definition.service';
import { RestapiService } from 'src/app/service/api/restapi.service';
import { Router } from '@angular/router';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';
import { File } from '@ionic-native/file/ngx';
import { ActionSheetController } from '@ionic/angular';
import { ActionlistenService } from 'src/app/service/actionlisten.service';
import { FilePath } from '@ionic-native/file-path/ngx';
import { FileChooser } from '@ionic-native/file-chooser/ngx';
import { Base64 } from '@ionic-native/base64/ngx';
import { DomSanitizer } from '@angular/platform-browser';
import { IOSFilePicker } from '@ionic-native/file-picker/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

@Component({
  selector: 'app-panupdate',
  templateUrl: './panupdate.component.html',
  styleUrls: ['./panupdate.component.scss'],
})
export class PanUpdateComponent implements OnInit {
  public panform: FormGroup;
  languageConext: any;
  headerTitle: any;
  currentpath;
  formsubmitted: boolean = false;
  imagePickerOptions = {
    maximumImagesCount: 1,
    quality: 50
  };

  imgUrl: any;
  FronImgName: any;
  FileSelected: any;
  Filearray: any;
  FrontImgFile: any;
  TrustFrontImgFile: any;
  file1: any = {};
  file2: any = {};
  pannumber: any;
  agreecheck: boolean = false;
  panverificationheaders: any;
  nsdlVerification: any;
  panStatus: any;
  pancardlength: any;
  addplatform: any
  constructor(public formBuilder: FormBuilder,
    private router: Router,
    public http: HttpClient,
    public navctrl: NavController,
    public platform: Platform,
    public cmndeclaration: CommonDeclarationService,
    public cmndef: CommonDefinitionService,
    private camera: Camera,
    public actionSheetController: ActionSheetController,
    private file: File,
    public api: RestapiService,
    private filePath: FilePath,
    private fileChooser: FileChooser,
    private base64: Base64,
    public actionVal: ActionlistenService,
    public _DomSanitizer: DomSanitizer,
    public menuCtrl: MenuController,
    public iosfilepicker: IOSFilePicker,
    public toastController: ToastController,
    public statusBar: StatusBar) {

    this.currentpath = this.router.url;

    if (this.cmndeclaration.LanguageJson) {
      this.languageConext = this.cmndeclaration.LanguageJson['pages'][0].panform;
      console.log("a", this.languageConext.ownername);
    }
    else {
      this.cmndeclaration.LanguageJson = JSON.parse(localStorage.languageJson);
      this.languageConext = this.cmndeclaration.LanguageJson['pages'][0].panform;
      console.log("b", this.languageConext);
    }

    this.headerTitle = this.languageConext.heading.text;
    this.panform = formBuilder.group({
      pannumber: ['', Validators.compose([
        Validators.required,
        Validators.pattern('^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$')
      ])]
    });
    this.TrustFrontImgFile = 'assets/images/panuploadIcon.PNG';
  }

  formheader() {
    this.panverificationheaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-IBM-Client-Id': '22da94c0-629d-48a2-90ce-04074453a3b8',
      'X-IBM-Client-Secret': 'xF1pS3mF5uM2cH7bW8kQ2nG4fV3kI5nF8fI0qK7vS4wK0iK3xX',
      'subject': 'Customer Services',
      'mettype': 'other'
    });
  }
  

  async presentToast(msg, addplatform) {
    const toast = await this.toastController.create({
      message: msg,
      duration: 3000,
      position: 'bottom',
      mode: addplatform,
      keyboardClose: true
    });
    toast.present();
  }

  ngOnInit() {

  }

  ionViewWillEnter() {
    this.menuCtrl.swipeEnable(false);
  }

  async panupdate() {
    if(this.nsdlVerification != "yes") {
      if (this.FronImgName == "" || this.FronImgName == undefined) {
          return false;
      }
    }

    if (this.panform.valid && this.agreecheck) {
      this.cmndef.loaderstart();
      var data = {};
      var fileDetails = [
        {
          "fileContent": this.FrontImgFile,
          "fileContentName": this.FronImgName
        }
      ];
      data['userSessionID'] = localStorage.userSessionID;
      data['panNumber'] = this.panform.value.pannumber.toUpperCase();
      data['userChatSessionID'] = localStorage.userChatSessionId;
      data['actionType'] = 'PAN_UPDATE';
      data['actionVal'] = fileDetails;
      data['nsdlVerification'] = this.nsdlVerification;
      data['status'] = this.panStatus;
      console.log(data)
      this.api.clickenventcap("submit_" + this.cmndef.TrakcerFromValue[this.cmndef.router.url]);
      await this.api.postapi("akeiraVAAction", data).then(async data => {
        let res = data;
        console.log(data);
        this.cmndef.loaderend();
        this.cmndeclaration.TamlismaJson = res["chatResp"][0];
        sessionStorage.CurrentPage = "/va/chat";
        this.navctrl.navigateForward("/va/chat");
      });
    } else {
      console.log("not valid");
    }
  }

  termscont() {
    if (this.agreecheck == false)
      this.agreecheck = true
    else
      this.agreecheck = false
  }


  /***********************pan upload ********************** */
  pickImage(sourceType) {
    let date = new Date();
    const options: CameraOptions = {
      quality: localStorage.imagequality,
      sourceType: sourceType,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE
    }
    this.camera.getPicture(options).then(async (imageData) => {
      if (this.platform.is('ios')) {
        await this.statusBar.overlaysWebView(true);
        await this.statusBar.overlaysWebView(false);
      }
      let base64Image = 'data:image/jpeg;base64,' + imageData;
      let stringLength: number = Number(imageData.length);
      let sizeInBytes = 4 * Math.ceil((stringLength / 3)) * 0.5624896334383812;
      let sizeInMB = sizeInBytes / 1000000;
      if (Math.floor(sizeInMB) <= Number(localStorage.imgsize)) {
        if (imageData.indexOf("file:/") != -1) {
          this.base64.encodeFile(imageData).then((base64File: string) => {
            if (this.FileSelected == "front") {
              this.FronImgName = imageData.substring(imageData.lastIndexOf("/") + 1, imageData.length);
              this.TrustFrontImgFile = this._DomSanitizer.bypassSecurityTrustUrl(base64File);
              this.FrontImgFile = base64File;
            }
          });
        } else {
          if (this.FileSelected == "front") {
            this.FronImgName = "IMG_" + date.getFullYear() + date.getMonth() + date.getDate() + date.getHours() + date.getMinutes() + date.getSeconds() + date.getMilliseconds() + ".jpeg",
              this.TrustFrontImgFile = this._DomSanitizer.bypassSecurityTrustUrl(base64Image);
            this.FrontImgFile = base64Image;
          }
        }
      } else
        this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].maxfilesizalwd + " " + localStorage.imgsize + "MB", "invalid");
    },async(err) => {
      if (this.platform.is('ios')) {
          await this.statusBar.overlaysWebView(true);
          await this.statusBar.overlaysWebView(false);
        }
    });
  }

  async selectImage(flg: any) {
    this.FileSelected = flg;
    this.cmndeclaration.Actionsheetenable = true;
    const actionSheet = await this.actionSheetController.create({
      header: "Select Image source",
      buttons: [{
        text: 'Load from Library',
        handler: () => {
          this.cmndeclaration.Actionsheetenable = false;
          if (this.cmndeclaration.runPlatform == "ios")
            this.IOSFileselect();
          else
            this.Fileselect();
        }
      },
      {
        text: 'Use Camera',
        handler: () => {
          this.cmndeclaration.Actionsheetenable = false;
          this.pickImage(this.camera.PictureSourceType.CAMERA);
        }
      },
      {
        text: 'Cancel',
        role: 'cancel',
        handler: () => {
          this.cmndeclaration.Actionsheetenable = false;
        }
      }
      ]
    });
    await actionSheet.present();
  }

  async IOSFileselect() {
    let filePath: any;
    let fileName: any;
    let path: any;
    let validFormate: any;
    let stringLength: any;
    await this.iosfilepicker.pickFile().then(async uri => {
      filePath = "file://" + uri;
      fileName = filePath.split('/').pop();
      path = filePath.substring(0, filePath.lastIndexOf("/") + 1);
      this.file.readAsDataURL(path, fileName).then(base64File => {
        sessionStorage.demo = base64File;
        validFormate = fileName.substring(fileName.lastIndexOf("."), fileName.length);
        if (validFormate.toLowerCase() == ".jpg" || validFormate.toLowerCase() == ".jpeg" || validFormate.toLowerCase() == ".pdf" || validFormate.toLowerCase() == ".tiff" || validFormate.toLowerCase() == ".png") {
          stringLength = base64File.substring(base64File.indexOf("64,") + 3, base64File.length);
          stringLength = stringLength.length;
          console.log(stringLength);
          let sizeInBytes = 4 * Math.ceil((stringLength / 3)) * 0.5624896334383812;
          let sizeInMB = sizeInBytes / 1000000;
          if (Math.round(sizeInMB) <= Number(localStorage.imgsize)) {
            if (this.FileSelected == "front") {
              this.FronImgName = fileName;
              this.FrontImgFile = base64File;
              if (validFormate.toLowerCase() == ".pdf")
                this.TrustFrontImgFile = "assets/images/pdfimg.PNG"
              else
                this.TrustFrontImgFile = this._DomSanitizer.bypassSecurityTrustUrl(base64File);
            }
          } else
            this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].maxfilesizalwd + " " + localStorage.imgsize + "MB", "invalid");
        } else
          this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].invalidImage, "invalid");
      })
        .catch(() => {
          console.log('Error reading file');
        })
    })
      .catch(err => console.log('Error', err));
  }

  Fileselect() {
    let validFormate: any;
    let stringLength: any;
    if (this.platform.is('android')) {
      this.fileChooser.open()
        .then(
          uri => {
            this.filePath.resolveNativePath(uri)
              .then(url => {
                var fileName = url.substring(url.lastIndexOf("/") + 1);
                validFormate = url.substring(url.lastIndexOf("."), url.length);
                console.log(validFormate);
                if (validFormate.toLowerCase() == ".jpg" || validFormate.toLowerCase() == ".jpeg" || validFormate.toLowerCase() == ".pdf" || validFormate.toLowerCase() == ".tiff" || validFormate.toLowerCase() == ".png") {
                  this.base64.encodeFile(url).then((base64File: string) => {
                    if (validFormate.toLowerCase() == ".pdf") {
                      stringLength = base64File.indexOf("64,") + 3;
                      base64File = "data:application/pdf;base64," + base64File.substring(stringLength, base64File.length);
                      stringLength = base64File.length - 'data:application/pdf;base64,'.length;
                    } else
                      stringLength = base64File.length - 'data:image/png;base64,'.length;

                    let sizeInBytes = 4 * Math.ceil((stringLength / 3)) * 0.5624896334383812;
                    let sizeInMB = sizeInBytes / 1000000;
                    if (Math.round(sizeInMB) <= Number(localStorage.imgsize)) {
                      if (this.FileSelected == "front") {
                        this.FronImgName = fileName;
                        if (validFormate.toLowerCase() == ".pdf")
                          this.TrustFrontImgFile = "assets/images/pdfimg.PNG"
                        else
                          this.TrustFrontImgFile = this._DomSanitizer.bypassSecurityTrustUrl(base64File);
                        this.FrontImgFile = base64File;
                        console.log(this.TrustFrontImgFile);

                      }
                    } else {
                      this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].maxfilesizalwd + " " + localStorage.imgsize + "MB", "invalid")
                    }
                  });
                } else {
                  this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].invalidImage, "invalid")
                }

              })
              .catch(err => console.log(err));
          }
        )
        .catch(error => {
          console.log(error)
        });
    }
  }

  async verifyPan(pannumber: any, accessToken: any) {
    var newpanverificationheaders = new HttpHeaders({
      'Content-Type':'application/json',
      'Authorization': accessToken,
      'X-IBM-Client-Id': '22da94c0-629d-48a2-90ce-04074453a3b8',
      'X-IBM-Client-Secret':'xF1pS3mF5uM2cH7bW8kQ2nG4fV3kI5nF8fI0qK7vS4wK0iK3xX',
      'requestId':'b1c97234-9ee3-41cc-87e1-47e05503aaf4',
      'channel':'atm',
    });

    console.log(newpanverificationheaders);
    console.log("getting policy no from localStorage" +localStorage.getItem('policyNo'));
    var policyNo = localStorage.getItem('policyNo');
    let newdata = JSON.stringify({
      "pan": pannumber.toUpperCase(),
      "reqType": "2",
      "appNo": "",
      "polNo": policyNo,
      "source": "Khushi"
    });
    console.log(newdata);
    await this.http.post("https://connect.pnbmetlife.com/pmli/business-api/pan/v1/verify", newdata, {headers: newpanverificationheaders})
    .subscribe(async data => {
      console.log(data);
      let getData: any;
      getData = data;
      if(this.platform.is('ios')) {
        this.addplatform = 'ios'
      } else {
        this.addplatform = 'md';
      }
      if(getData.httpCode == "200") {
        this.nsdlVerification = "yes";
        console.log(getData.panResponse.panStatus);
        this.panStatus = getData.panResponse.panStatus;
        this.presentToast(this.languageConext.panverification.success, this.addplatform);
        // this.presentToast("success", this.addplatform);
      } else {
        console.log(getData.errorCode);
        this.panStatus = '';
        this.nsdlVerification = getData.errorCode + " " + getData.errorDetails;
        // this.presentToast(this.languageConext.panverification.error, this.addplatform);
        // this.presentToast("error", this.addplatform);
      }
      this.cmndef.loaderend();
    }, err => {
      console.log(err);
      this.cmndef.loaderend();
    });
  }

  /********************pan uplaod*****************************/
  async validatefun(event: any, flg: any) {
    
    console.log(event.target.value.length);
    if(flg == 'pannumber' && event.target.value.length == 10) {
      this.pancardlength = event.target.value.length;
      // await this.api.panVerification(event.target.value);
      await this.cmndef.loaderstart();
      let getResponse: any;
      await this.formheader();

      await this.http.get("https://connect.pnbmetlife.com/pmli/business-api/v1/token-wa", { headers: this.panverificationheaders }).subscribe(async data => {
        // console.log(data);
        getResponse = data;
        console.log(getResponse.accessToken);
        await this.verifyPan(event.target.value, getResponse.accessToken);
      }, err => {
        console.log(err);
        this.cmndef.loaderend();
      })
    } else {
      this.nsdlVerification = '';
      this.panStatus = '';
    }
    // console.log(this.pannumber);
    if (flg == 'pannumber') {
      this.pannumber = this.pannumber.replace(/[^a-zA-Z0-9]+/g, '');
    }
  }

  changeListener($event, flg): void {
    let name: any;
    let validFormate: any;
    let imgname: any;
    let sizeInBytes: any;
    let stringLength: any;
    let sizeInMB: any;
    name = $event.target.files[0].name;
    this.FileSelected = flg;
    validFormate = name.substring(name.lastIndexOf("."), name.length);

    if (validFormate.toLowerCase() == ".jpg" || validFormate.toLowerCase() == ".jpeg" || validFormate.toLowerCase() == ".pdf" || validFormate.toLowerCase() == ".tiff" || validFormate.toLowerCase() == ".png") {
      this.cmndef.readThis($event.target).then(data => {
        imgname = data;
        stringLength = imgname.length - imgname.indexOf("64,") + 3;
        sizeInBytes = 4 * Math.ceil((stringLength / 3)) * 0.5624896334383812;
        sizeInMB = sizeInBytes / 1000000;
        console.log(sizeInMB);
        if (Math.round(sizeInMB) <= Number(localStorage.imgsize)) {
          if (this.FileSelected == "front") {
            this.FronImgName = name;
            this.FrontImgFile = imgname;
            if (validFormate.toLowerCase() == ".pdf")
              this.TrustFrontImgFile = "assets/images/pdfimg.PNG"
            else
              this.TrustFrontImgFile = this._DomSanitizer.bypassSecurityTrustUrl(imgname);
          }
        } else {
          this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].maxfilesizalwd + " " + localStorage.imgsize + "MB", "invalid")
        }
      })
    } else {
      this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].invalidImage, "invalid")
    }
  }
}